<template>
  <div class="dxs_cell" :class="{'showAll':showAll}" v-if="btnOptions.length">
    <div class="title">{{ title }}:</div>
    <div class="wrapper">
      <div class="item" v-for="(item,index) in btnOptions" :key="index">
        <div
          class="label"
          :class="{'active':isClick === index}"
          @click="handleClick(item,index)"
        >{{item.label}}</div>
      </div>
    </div>
    <!-- <div class="more">
        <span class="desc" @click="showAll = !showAll">
        <div>{{ !showAll ? '显示全部' : '收起'}}</div></span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClick: 0,
      showAll:false
    };
  },
  props: {
    btnOptions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick(item, index) {
      this.isClick = index;
      this.$emit("handleClick", item);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>